import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a1241aa45120ce44b1d82c2f6ec56fc3cb from "./generated-9eceb2ee-b874-46ac-a683-9c61bf55fef7.json";

import abbdf7b4fce69a0385b5173f5de6a3981b from "./generated-38242462-58a2-4f9d-97c1-b26647d03811.json";

import a8aec6cf2ad4faf5ae6582d08d1f0d2fcb from "./generated-e23a5a84-0045-4a4d-a89c-17770d9ad820.json";

import a8b852d3b692124cad903065398a26007b from "./generated-61af7f24-ac1f-4fed-8dd7-41b591735a58.json";

import a493b57151728b15b553ce0adfd49e1b6b from "./generated-82f1092c-dc12-451b-a7f5-6dbf06c6557c.json";

import a73d7660ac010577823bf5bbe7a5693a2b from "./generated-34ed303f-9363-4a07-b6d5-f1e0f3b81f4c.json";

import abe8a1fe07a91bbbdca949f4a72092950b from "./generated-d8c88d2c-57fd-4b63-9d6c-6acfb3866592.json";

import ad72121ee2ff04b1840efcb23e5ca9039b from "./generated-ad0eabb5-4dd4-457c-9b6d-9b28a2d75cdd.json";

import acb0aa3d64da5cd796e27cf3cc56d7b1bb from "./generated-a1c1a4ed-7f52-4ab7-ad44-7911ff8dc4f2.json";

import a049df7180f7fbd450f318f70516a4fddb from "./generated-89957d52-590b-4a44-bf6d-23f2b1c794ff.json";

import a538c739cdbd4a77c12b998a9af881bdcb from "./generated-54875c35-178d-4807-baf0-6ba92740ea7d.json";

import ab660d4e912668c82917f359948f7e5cfb from "./generated-089a4c4c-8d8e-4056-bcb9-4cdc1e0e4c67.json";

import a2372b61ba102305bb6d141437700e7abb from "./generated-90078eaa-b53b-41dc-a619-1ab1c8a7e5e1.json";

import adb7f5fbb847d16d9f941e2dbc20bf0d0b from "./generated-d08f2ccc-74d6-4370-bb28-b48495991021.json";

import a0b3198b4fa937f4433b5de69cd3481d6b from "./generated-2fd895b3-d72a-4798-9370-0ff5d34e32c3.json";

import a64cbfb1ef9f6d3f7d68032e41cf0251bb from "./generated-88794ab9-90d4-4e12-bcd1-e14e44161f1d.json";

import a23be0f811b243a617a59791001985c8bb from "./generated-e07a85fe-b9b8-4b5f-ace6-0bccf89c4d20.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a1241aa45120ce44b1d82c2f6ec56fc3cb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(abbdf7b4fce69a0385b5173f5de6a3981b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a8aec6cf2ad4faf5ae6582d08d1f0d2fcb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a8b852d3b692124cad903065398a26007b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a493b57151728b15b553ce0adfd49e1b6b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a73d7660ac010577823bf5bbe7a5693a2b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(abe8a1fe07a91bbbdca949f4a72092950b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ad72121ee2ff04b1840efcb23e5ca9039b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(acb0aa3d64da5cd796e27cf3cc56d7b1bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a049df7180f7fbd450f318f70516a4fddb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a538c739cdbd4a77c12b998a9af881bdcb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ab660d4e912668c82917f359948f7e5cfb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(acb0aa3d64da5cd796e27cf3cc56d7b1bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a2372b61ba102305bb6d141437700e7abb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(adb7f5fbb847d16d9f941e2dbc20bf0d0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(acb0aa3d64da5cd796e27cf3cc56d7b1bb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a0b3198b4fa937f4433b5de69cd3481d6b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a64cbfb1ef9f6d3f7d68032e41cf0251bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a23be0f811b243a617a59791001985c8bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a0b3198b4fa937f4433b5de69cd3481d6b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */